import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';

import TableContainer from '../../../../../Components/Common/TableContainer';

import { useMatch } from 'react-router';
import { getTransactions } from '../../slice';
import { columns } from './columns';

export const Transactions: React.FC = () => {
  const { transactions } = useAppSelector((state) => state.userDetails);

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getTransactions(Number(userId)));
  }, [dispatch]);

  return (
    <>
      <TableContainer
        columns={columns}
        data={transactions || []}
        divClass='table-responsive table-card mb-1'
        tableClass='align-middle table-nowrap'
        theadClass='table-light text-muted'
      />
    </>
  );
};
